import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { renderError } from "../../utils/ModuleFunctions";
import AxiosInstance from "../../utils/AxiosInstance";
import { ToastContainer, toast } from "react-toastify";
import * as Yup from "yup";
import { useParams } from "react-router-dom";

export default function RegistrationForm(props) {
	const { id } = useParams();

	const initialValues = {
		boarding: {
			bedMattress: false,
			studyTables: false,
			ceilingFans: false,
			wardrobes: false,
			studyRoom: false,
			airCondition: false,
		},
		capacity: {
			ensuitsBathRoomsTotal: "",
			sharedBathRoomsTotal: "",
			roomsTotal: "",
			studentsTotal: "",
		},
		cateringAndRecreational: {
			shops: false,
			sellingProducts: "",
			tvRoom: false,
			kitchenttes: false,
			commonKitchen: false,
		},
		tenancy: {
			signTenancy: false,
			giveTenancyDoc: false,
		},
		rentalCharges: {
			twoInOne: "",
			threeInOne: "",
			fourInOne: "",
			others: "",
			includeWaterBill: false,
			includeWasteBill: false,
			includeGasBill: false,
			includeElectricity: false,
		},

		safetyAndSecurity: {
			floorsTotal: "",
			activeExtinguishers: false,
			separateMeter: false,
			connectedMeter: false,
			cctv: false,
			floorCctvTotal: "",
			assemblingPoint: false,
		},

		managersTotal: "",
		hallAssistantsTotal: "",
		securityTotal: "",
		filedBy: "",
		position: "",
		contact: "",

		office: {
			security: "",
			safety: "",
			sanitation: "",
			approvedBy: "",
		},

		addedBy: "",
	};

	const handleSubmit = async (values, resetForm) => {
		try {
			const res = await AxiosInstance({
				method: "post",
				url: `/api/v1/residences/assessment`,
				headers: {
					accept: "application/json",
				},
				data: {
					id,
				},
			});
			resetForm();
			toast.success(res.data.message);
			// navigate("/admin/residences");
		} catch (err) {
			if (err?.response.data?.message) {
				if (err?.response?.data?.message.startsWith("Can't extract")) {
					toast.error(
						"Please provide a correct coodinates for the Longitude and the Latitude",
						{ position: "top-center" }
					);
				} else {
					toast.error(err?.response?.data?.message, { position: "top-center" });
				}
			}
		}
	};

	return (
		<>
			<div className="container">
				<FormStepper
					initialValues={initialValues}
					onSubmit={async (values, resetForm) => {
						await handleSubmit(values, resetForm);
					}}
				>
					<FormikStep
						validationSchema={Yup.object({
							boarding: Yup.object({
								bedMattress: Yup.boolean(),
								studyTables: Yup.boolean(),
								ceilingFans: Yup.boolean(),
								studyRoom: Yup.boolean(),
								airCondition: Yup.boolean(),
							}),
						})}
					>
						<div className="assess-card">
							<h5 className="text-center ">BOARDING AND LEARNING FACILITIES</h5>
							<div className="row">
								<div className="col-md-6 col-sm- my-3">
									<div role="group" aria-labelledby="accessibility-radio-group">
										<p>Conditions</p>
										<label className="label-spacing">
											<Field type="checkbox" name="boarding.bedMattress" />
											<b className="mx-2">Bed and mattress for each student</b>
										</label>
										<br />
										<label>
											<Field type="checkbox" name="boarding.studyTables" />
											<b className="mx-2">
												Study tables and chairs in the bedrooms
											</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field type="checkbox" name="boarding.ceilingFans" />
											<b className="mx-2">Ceiling Fans in bedrooms </b>
										</label>
										<br />
										<label className="label-spacing">
											<Field type="checkbox" name="boarding.wardrobes" />
											<b className="mx-2">Wardrobes in bedrooms </b>
										</label>
										<br />

										<label className="label-spacing">
											<Field type="checkbox" name="boarding.studyRoom" />
											<b className="mx-2">common study room </b>
										</label>
										<br />
										<label className="label-spacing">
											<Field type="checkbox" name="boarding.airCondition" />
											<b className="mx-2">Air Conditon in the bedrooms </b>
										</label>
										<br />
									</div>
								</div>
								<div className="col-md-6 col-sm- my-3">
									<div role="group" aria-labelledby="accessibility-radio-group">
										<section> Hostel Capacity</section>
										<label className="label-spacing">
											<b className="mx-2">
												Number of rooms en-suite bathrooms/water-closets
											</b>
											<Field
												type="text"
												className="form-control"
												name="capacity.ensuitsBathRoomsTotal"
											/>
										</label>
										<br />
										<label className="label-spacing">
											<b className="mx-2">
												Number of rooms with shared en-suite bathrooms
											</b>
											<Field
												type="text"
												className="form-control"
												name="capacity.sharedBathRoomsTotal"
											/>
										</label>
										<br />
										<label className="label-spacing">
											<b className="mx-2">Total Number of Rooms</b>
											<Field
												type="text"
												className="form-control"
												name="capacity.roomsTotal"
											/>
										</label>
										<br />
										<ErrorMessage
											name="capacity.roomsTotal"
											render={renderError}
										/>
										<label className="label-spacing">
											<b className="mx-2">Total Number of Students</b>
											<Field
												type="text"
												className="form-control"
												name="capacity.studentsTotal"
											/>
										</label>
										<br />
										<ErrorMessage
											name="capacity.studentsTotal"
											render={renderError}
										/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-6 col-sm-12 mt-4">
									<div role="group" aria-labelledby="area-radio-group">
										<section>Catering and Recreational Facilities</section>
										<div
											role="group"
											aria-labelledby="accessibility-radio-group"
										>
											<label className="label-spacing">
												<Field
													type="checkbox"
													name="cateringAndRecreational.shops"
												/>
												<b className="mx-2">Do you have a shop for selling </b>
											</label>
											<br />
											<label>
												<b className="mx-2">if Yes, what do you sell</b>
												<br />
												<Field
													type="text"
													className="form-control"
													name="cateringAndRecreational.sellingProducts"
												/>
											</label>
											<br />
											<label className="label-spacing">
												<Field
													type="checkbox"
													name="cateringAndRecreational.tvRoom"
												/>
												<b className="mx-2">Do you have a Tv Room </b>
											</label>
											<br />
											<label className="label-spacing">
												<Field
													type="checkbox"
													name="cateringAndRecreational.kitchenettes"
												/>
												<b className="mx-2">Do you have private Kitchenettes</b>
											</label>
											<br />

											<label className="label-spacing">
												<Field
													type="checkbox"
													name="cateringAndRecreational.commonKitchen"
												/>
												<b className="mx-2">Do you have common kitchen </b>
											</label>
											<br />
										</div>
									</div>
								</div>
								<div className="col-md-6 col-sm-12 mt-4">
									<div role="group" aria-labelledby="area-radio-group">
										<section>Tenancy Agreement</section>
										<div
											role="group"
											aria-labelledby="accessibility-radio-group"
										>
											<label className="label-spacing">
												<Field
													type="checkbox"
													name="cateringAndRecreational.shops"
												/>
												<b className="mx-2">Do you Sign Tenancy Agreement </b>
											</label>
											<br />

											<br />
											<label className="label-spacing">
												<Field
													type="checkbox"
													name="cateringAndRecreational.tvRoom"
												/>
												<b className="mx-2">
													Do you give a copy to the students{" "}
												</b>
											</label>
											<br />
										</div>
									</div>
								</div>
							</div>
						</div>

						<hr className="my-3" />
					</FormikStep>
					<FormikStep
						validationSchema={Yup.object({
							rentalCharges: Yup.object({
								twoInOne: Yup.string(),
								threeInOne: Yup.string(),
								fourInOne: Yup.string(),
								others: Yup.string(),
								includeWaterBill: Yup.boolean(),
								includeWasteBill: Yup.boolean(),
								includeGasBill: Yup.boolean(),
								includeElectricity: Yup.boolean(),
							}),
						})}
					>
						<div className="row">
							<div className="col-md-6 col-sm- my-3">
								<div role="group" aria-labelledby="accessibility-radio-group">
									<section> Hostel Charges</section>
									<label className="label-spacing">
										<b className="mx-2">Two-in-One Room</b>
										<Field
											type="text"
											className="form-control"
											name="rentalCharges.twoInOne"
										/>
									</label>
									<br />
									<label className="label-spacing">
										<b className="mx-2">Three - in - One Room</b>
										<Field
											type="text"
											className="form-control"
											name="rentalCharges.threeInOne"
										/>
									</label>
									<br />
									<label className="label-spacing">
										<b className="mx-2">Four - In - One Room </b>
										<Field
											type="text"
											className="form-control"
											name="rentalCharges.fourInOne"
										/>
									</label>
									<br />
									<ErrorMessage
										name="capacity.roomsTotal"
										render={renderError}
									/>
									<label className="label-spacing">
										<b className="mx-2">Other</b>
										<Field
											type="text"
											className="form-control"
											name="rentalCharges.others"
										/>
									</label>
									<br />
									<ErrorMessage
										name="rentalCharges.others"
										render={renderError}
									/>
								</div>
							</div>
							<div className="col-md-6 col-sm- my-3">
								<div role="group" aria-labelledby="accessibility-radio-group">
									<p>Charges Criteria</p>
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="rentalCharges.includeWaterBill"
										/>
										<b className="mx-2">Does the Price include Water Bill</b>
									</label>
									<br />
									<label>
										<Field
											type="checkbox"
											name="rentalCharges.includeWasteBill"
										/>
										<b className="mx-2">Does the price include Waste Bill</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="rentalCharges.includeElectricity"
										/>
										<b className="mx-2">
											Does the price include Electricity Bill
										</b>
									</label>
									<br />
								</div>
							</div>
							<div className="col-md-6 col-sm-12 mt-4">
								<div role="group" aria-labelledby="area-radio-group">
									<p>Safety and Security</p>
									<label className="label-spacing">
										<b className="mx-2">Total Number of Floors</b>
										<Field
											type="text"
											className="form-control"
											name="safetyAndSecurity.floorsTotal"
										/>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="safetyAndSecurity.activeExtinguishers"
										/>
										<b className="mx-2">Active Extinguishers</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="safetyAndSecurity.separateMeter"
										/>
										<b className="mx-2">Do you have separate meter</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="safetyAndSecurity.connectedMeter"
										/>
										<b className="mx-2">Connected Meter </b>
									</label>
									<br />
								</div>
							</div>
							<div className="col-md-6 col-sm-12 mt-4">
								<div role="group" aria-labelledby="area-radio-group">
									<p>CCTV Cameras</p>
									<label className="label-spacing">
										<Field type="checkbox" name="safetyAndSecurity.cctv" />
										<b className="mx-2">Do you have CCTV Camera ?</b>
									</label>
									<br />
									<label className="label-spacing">
										<b className="mx-2">Total Number of CCTV Cameras</b>
										<Field
											type="text"
											className="form-control"
											name="safetyAndSecurity.floorCctvTotal"
										/>
									</label>

									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="safetyAndSecurity.assemblingPoint"
										/>
										<b className="mx-2">Do you have assembling point</b>
									</label>
									<br />
								</div>
							</div>
						</div>

						<hr className="my-3" />
					</FormikStep>

					<FormikStep>
						<h2>Management</h2>
						<div className="row">
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Total No. of Managers</b>
								</label>
								<Field
									type="text"
									className="form-control"
									// placeholder="Male Capacity"
									name="managersTotal"
								/>
								<p className="eg-text">
									{" "}
									<span className="required">*</span> Example: 2
								</p>
								<ErrorMessage name="managersTotal" render={renderError} />
							</div>
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Number of Hall Assistants</b>
								</label>
								<Field
									type="number"
									className="form-control"
									// placeholder="Femaile Capacity"
									name="hallAssistantsTotal"
								/>
								<p className="eg-text">
									{" "}
									<span className="required">*</span> Example: 2
								</p>
								<ErrorMessage name="hallAssistantsTotal" render={renderError} />
							</div>
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Total No. of Securities</b>
								</label>
								<Field
									type="text"
									className="form-control"
									// placeholder="Male Capacity"
									name="securityTotal"
								/>
								<p className="eg-text">
									{" "}
									<span className="required">*</span> Example: 2
								</p>
								<ErrorMessage name="securityTotal" render={renderError} />
							</div>
						</div>
						<div className="row">
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Filed By</b>
								</label>
								<Field
									type="text"
									className="form-control"
									// placeholder="Femaile Capacity"
									name="filedBy"
								/>
								<p className="eg-text">
									{" "}
									<span className="required">*</span> Example: Kwabena Fosu
								</p>
								<ErrorMessage name="filedBy" render={renderError} />
							</div>
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Position</b>
								</label>
								<Field
									type="text"
									className="form-control"
									// placeholder="Femaile Capacity"
									name="position"
								/>
								<p className="eg-text">
									{" "}
									<span className="required">*</span> Example: Manager
								</p>
								<ErrorMessage name="Position" render={renderError} />
							</div>
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Contact</b>
								</label>
								<Field
									type="text"
									className="form-control"
									// placeholder="Femaile Capacity"
									name="Contact"
								/>
								<p className="eg-text">
									{" "}
									<span className="required">*</span> Example: 0542399377
								</p>
								<ErrorMessage name="Contact" render={renderError} />
							</div>
						</div>
						<hr />
						<h2>Office Use </h2>
						<div className="row">
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Security</b>
								</label>
								<Field as="select" className="form-control" name="security">
									<option value="Good">Good</option>
									<option value="Very_Good">Very Good</option>
									<option value="Best">Best</option>
								</Field>
								<ErrorMessage name="security" render={renderError} />
							</div>
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Safety</b>
								</label>
								<Field as="select" className="form-control" name="safety">
									<option value="Good">Good</option>
									<option value="Very_Good">Very Good</option>
									<option value="Best">Best</option>
								</Field>
								<ErrorMessage name="safety" render={renderError} />
							</div>
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Sanitation</b>
								</label>
								<Field as="select" className="form-control" name="sanitation">
									<option value="Good">Good</option>
									<option value="Very_Good">Very Good</option>
									<option value="Best">Best</option>
								</Field>
								<ErrorMessage name="sanitation" render={renderError} />
							</div>
						</div>
						<div className="row my-3">
							<div className="col-md-4 col-sm-12">
								<label>
									<b>Approved By</b>
								</label>
								<Field type="text" className="form-control" name="approvedBy" />
								<p className="eg-text">
									{" "}
									<span className="required">*</span> Example: Mr. Alex Akaele
								</p>
								<ErrorMessage name="approvedBy" render={renderError} />
							</div>
						</div>
					</FormikStep>
				</FormStepper>
			</div>
		</>
	);
}

export function FormikStep({ children }) {
	return <>{children}</>;
}

export function FormStepper({ children, ...props }) {
	const childrenArray = React.Children.toArray(children);
	const [step, setStep] = useState(0);
	// const [isSubmitting, setSubmit] = useState(false);
	// const [completed, setCompleted] = useState(false);
	const currentChild = childrenArray[step];

	function isLastPage() {
		return step === childrenArray.length - 1;
	}

	return (
		<Formik
			{...props}
			validationSchema={currentChild.props?.validationSchema}
			onSubmit={async (values, { resetForm }) => {
				if (isLastPage()) {
					props.onSubmit(values, resetForm);
				} else {
					setStep((s) => s + 1);
				}
			}}
		>
			<Form>
				<ToastContainer className="top-margin" />
				{currentChild}

				{step > 0 ? (
					<button
						type="button"
						style={{ marginRight: 12 }}
						onClick={() => setStep((s) => s - 1)}
						className="btn mb-5 px-3 py-2"
					>
						Back
					</button>
				) : (
					""
				)}
				<button type="submit" className="btn mb-5  py-2 px-3">
					{isLastPage() ? "Submit" : "Next"}
				</button>
			</Form>
		</Formik>
	);
}
